// extracted by mini-css-extract-plugin
module.exports = {"bannerWrapper":"_30yf3","registrationWrapper":"_2FceF"};